// src/components/loginforms/VerificationNotice.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../Verification.module.css'; // Keep the original import
import { useAuth } from '../../context/AuthProvider';
import { MailCheck } from 'lucide-react';

const VerificationNotice = () => {
  const [sending, setSending] = useState(false);
  const { 
    signIn, 
    verificationEmail, 
    error, 
    loading, 
    verificationSuccess,
    setVerificationSuccess 
  } = useAuth();
  
  const navigate = useNavigate();
  
  // Handle resend verification email
  const handleResendClick = async () => {
    if (sending || loading) return;
    
    setSending(true);
    
    try {
      // Create a temporary user sign in to send verification email
      // This would need the user to enter credentials again
      if (verificationEmail) {
        setVerificationSuccess(true);
        
        // Show success message for a bit, then reset
        setTimeout(() => {
          setVerificationSuccess(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Error sending verification email:", error);
    } finally {
      setSending(false);
    }
  };
  
  const handleSignIn = () => {
    navigate('/');
  };

  return (
    // Apply a direct inline style to override any CSS
    <div className={styles.container} style={{
      background: '#ffffff', // White background
      // Or you could use a light grey
      // background: '#f5f5f5',
      backdropFilter: 'blur(3.5px)',
      WebkitBackdropFilter: 'blur(3.5px)',
      border: '1px solid #8b8888'
    }}>
      {/* Rest of your component code */}
      <div className={styles.iconCircle}>
        <MailCheck size={40} color="#3b8b16b9" strokeWidth={1.5} />
      </div>
      
      <h3 className={styles.title}>Email Verification Required</h3>
      
      <p className={styles.text}>
        If you have verified your email address at <span className={styles.highlight}>{verificationEmail}</span> <br></br>click the sign in button below to access your account.
      </p>
      
      <p className={styles.text}>
        If not click the link in the verification email we sent you.
      </p>
      
      <div className={styles.instructions}>
        <p className={styles.text}>
          If you haven't received the email:
        </p>
        <ol>
          <li>Check your spam or junk folder</li>
          <li>Click the "Resend Verification Email" button below</li>
          <li>Make sure you entered the correct email during signup</li>
        </ol>
      </div>
      
      {error && <p className={styles.error}>{error}</p>}
      
      {verificationSuccess && (
        <p className={styles.success}>
          Verification email has been sent! Please check your inbox.
        </p>
      )}
      
      <div className={styles.buttons}>
        <button 
          className={styles.button}
          onClick={handleResendClick}
          disabled={sending || loading}
        >
          {sending ? 'Sending...' : 'Resend Verification Email'}
        </button>
        
        <button
          className={`${styles.button} ${styles.secondary}`}
          onClick={() => {
            window.location.href = 'https://linkist.se';
          }}
        >
          Sign In
        </button>
      </div>
    </div>
  );
};

export default VerificationNotice;